import React from "react";
import Slick from "../Slick/Slick";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n.jsx";

const Home = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const tmblog = {
    infinite: !0,
    autoplay: !0,
    pauseOnHover: !1,
    speed: 2e3,
    autoplaySpeed: 5e3,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: !1,
    dots: !1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const board1 = {
    infinite: !0,
    autoplay: !0,
    speed: 2e3,
    autoplaySpeed: 2e3,
    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: !1,
    arrows: !1,
    dots: !1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 420, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    ],
  };

  const tmproducts = {
    infinite: !0,
    autoplay: !0,
    pauseOnHover: !1,
    speed: 2e3,
    autoplaySpeed: 5e3,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: !1,
    dots: !1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    ],
  };

  return (
    <div>
      <div className="header-slider-men">
        <div
          id="carouselExampleIndicators"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators carousel-indicators-two">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={0}
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={1}
              aria-label="Slide 2"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={2}
              aria-label="Slide 3"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src="assets/images/heoslider-image-1.jpg"
                className="d-block w-100 header-photo"
                alt="Banner"
              />
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/heoslider-image-2.jpg"
                className="d-block w-100 header-photo"
                alt="Banner"
              />
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/heoslider-image-3.jpg"
                className="d-block w-100 header-photo"
                alt="Banner"
              />
            </div>
          </div>
          <button
            className="carousel-control-prev control-left-btn"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next control-right-btn"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <main className="page-content">
        <div className="tm-section tm-brandlogo-area tm-padding-section bg-white">
          <div className="container">
            <Slider {...board1} className="row tm-brandlogo-slider">
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-1.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-2.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-3.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-4.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-5.jpg" alt="Category" />
                </Link>{" "}
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-1.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-2.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-3.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-4.jpg" alt="Category" />
                </Link>
              </div>
              <div className="col-12 tm-brandlogo">
                <Link to="/products" onClick={handleLinkClick}>
                  <img src="assets/images/cat-5.jpg" alt="Category" />
                </Link>
              </div>
            </Slider>
          </div>
        </div>
        <div className="middle-banner-box">
          <div className="container">
            <div className="row" style={{ alignItems: "center" }}>
              <div className="col-lg-6 col-md-6 col-6">
                <div className="middle-one-box">
                  <Link to="/products" onClick={handleLinkClick}>
                    <img src="assets/images/middle-banner1.jpg" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-6">
                <div className="middle-one-box">
                  <Link to="/products" onClick={handleLinkClick}>
                    <img src="assets/images/middle-banner.jpg" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="tm-popular-products-area"
          className="tm-section tm-popular-products-area tm-padding-section-sm bg-white"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-12">
                <div className="tm-sectiontitle sectiontitle-four text-center">
                  <h3>{t("welcome_message")}</h3>
                  {/* <h1>{t('welcome_message')}</h1>; */}
                  {/* <p style="color: #000;">Our popular products are so beautyful to see that the shoppers are easily attracted
								to them.</p> */}
                </div>
              </div>
            </div>
            <Slider {...tmproducts} className="row tm-products-slider3">
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-1.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-2.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-3.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-4.jpg"
                          alt="product image"
                        />
                      </div>

                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-5.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-55.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-6.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-66.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-7.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-77.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-8.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-88.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-9.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-99.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Productdetails" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-image-10.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-image-110.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
            </Slider>
          </div>
        </div>
        <div className="tm-section-two">
          <div className="container-fulid">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <img
                  className="middle-bg1"
                  src="assets/images/middle-bg.jpg"
                  alt="banner image"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id="tm-popular-products-area"
          className="tm-section tm-popular-products-area tm-padding-section-sm bg-white middle-recommended"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-12">
                <div className="tm-sectiontitle sectiontitle-four text-center">
                  <h3>{t("welcome_message")}</h3>
                </div>
              </div>
            </div>
            <Slider {...tmproducts} className="row tm-products-slider3">
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-a.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-aa.jpg"
                          alt="product image"
                        />
                      </div>

                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-b.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-bb.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-c.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-cc.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-d.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-dd.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-e.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-ee.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-f.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-ff.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-g.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-gg.jpg"
                          alt="product image"
                        />
                      </div>
                      {/* <div class="tm-product-badges">
											<span class="tm-product-badges-new">Sale</span>
										</div> */}
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-12">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images product-images-two">
                        <img
                          src="assets/images/product-shop-h.jpg"
                          alt="product image"
                        />
                        <img
                          src="assets/images/product-shop-hh.jpg"
                          alt="product image"
                        />
                      </div>
                      <div className="tm-product-badges">
                        <span className="tm-product-badges-new">Sale</span>
                      </div>
                      <div className="tm-product-badges1">
                        <span className="tm-product-badges-new">
                          4.5
                          <i className="ion-android-star-outline star-outline-one" />
                        </span>
                      </div>
                      <div className="tm-product-badges2">
                        <span className="product-badges-size">S</span>
                        <span className="product-badges-size">M</span>
                        <span className="product-badges-size">L</span>
                        <span className="product-badges-size">XL</span>
                        <span className="product-badges-size">XXL</span>
                      </div>
                    </div>
                    <div className="tm-product-bottomside">
                      <h6 className="tm-product-title">
                     {t("Product description")}
                      </h6>
                      <span className="tm-product-price-two">
                        <b>₹1,199</b>
                      </span>
                      <span className="product-price-three tm-product-price-two">
                        ₹1,999
                      </span>
                      <span className="product-price-four">40% OFF</span>
                      <ul className="products-color">
                        <li className="products-color-a" />
                        <li className="products-color-b" />
                        <li className="products-color-c" />
                        <li className="products-color-d" />
                        <li className="products-color-e" />
                        <li className="products-color-f" />
                        <li className="products-color-g" />
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
            </Slider>
          </div>
        </div>
        <div
          id="tm-latest-products-area"
          className="tm-section tm-latest-products-area tm-padding-section bg-white"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-12">
                <div className="tm-sectiontitle sectiontitle-four text-center">
                  <h3>{t("my_collection")}</h3>
                </div>
              </div>
            </div>
            <div className="row mt-50-reverse">
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-50 middle-two-slide new-arrival-box">
                <div className="tm-product tm-scrollanim">
                  <div className="tm-product-topside">
                    <div className="tm-product-images">
                      <Link to="/Products" onClick={handleLinkClick}>
                        <img
                          src="assets/images/explore1.jpg"
                          alt="product image"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-50 middle-two-slide new-arrival-box">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images">
                        <img
                          src="assets/images/explore2.jpg"
                          alt="product image"
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-50 middle-two-slide new-arrival-box">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images">
                        <img
                          src="assets/images/explore3.jpg"
                          alt="product image"
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mt-50 middle-two-slide new-arrival-box">
                <div className="tm-product tm-scrollanim">
                  <Link to="/Products" onClick={handleLinkClick}>
                    <div className="tm-product-topside">
                      <div className="tm-product-images">
                        <img
                          src="assets/images/explore4.jpg"
                          alt="product image"
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="tm-news-area"
          className="tm-section tm-blog-area tm-padding-section bg-pattern-transparent"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-12">
                <div className="tm-sectiontitle sectiontitle-four text-center">
                  <h3>{t("Blogs")}</h3>
                </div>
              </div>
            </div>
            <Slider {...tmblog} className="row tm-blog-slider blog-oneBox">
              <div className="tm-blog tm-scrollanim blog-leftBox">
                <div className="tm-blog-topside">
                  <div className="tm-blog-thumb">
                    <img
                      src="assets/images/blog/blog-image-1.jpg"
                      alt="blog image"
                    />
                  </div>
                  <span className="tm-blog-metahighlight">April 30, 2024</span>
                </div>
                <div className="tm-blog-content">
                  <h6 className="tm-blog-title">
                    <Link to="/blogdetails" onClick={handleLinkClick}>
                    {t("blogdescription")}
                    </Link>
                  </h6>
                  {/* <ul class="tm-blog-meta">
									<li><a href="blog.html"><i class="ion-android-person"></i> Anderson</a></li>
									<li><a href="blog-details.html"><i class="ion-chatbubbles"></i> 3 Comments</a>
									</li>
								</ul> */}
                  <p>
                    {t("blogdescontent")}
                  </p>
                  {/* <Link
                    to="/blogdetails"
                    onClick={handleLinkClick}
                    className="tm-readmore"
                  >
                  {t("Readmore")}
                  </Link> */}
                </div>
              </div>
              <div className="tm-blog tm-scrollanim blog-leftBox">
                <div className="tm-blog-topside">
                  <div className="tm-blog-thumb">
                    <img
                      src="assets/images/blog/blog-image-2.jpg"
                      alt="blog image"
                    />
                  </div>
                  <span className="tm-blog-metahighlight">April 30, 2024</span>
                </div>
                <div className="tm-blog-content">
                  <h6 className="tm-blog-title">
                    <Link to="/blogdetails" onClick={handleLinkClick}>
                     {t("blogdescription")}
                    </Link>
                  </h6>
                  {/* <ul class="tm-blog-meta">
									<li><a href="blog.html"><i class="ion-android-person"></i> Anderson</a></li>
									<li><a href="blog-details.html"><i class="ion-chatbubbles"></i> 3 Comments</a>
									</li>
								</ul> */}
                  <p>
                    {t("blogdescontent")}
                  </p>
                  {/* <Link
                    to="/blogdetails"
                    onClick={handleLinkClick}
                    className="tm-readmore"
                  >
                   {t("Readmore")}
                  </Link> */}
                </div>
              </div>
              <div className="tm-blog tm-scrollanim blog-leftBox">
                <div className="tm-blog-topside">
                  <div className="tm-blog-thumb">
                    <img
                      src="assets/images/blog/blog-image-3.jpg"
                      alt="blog image"
                    />
                  </div>
                  <span className="tm-blog-metahighlight">April 30, 2024</span>
                </div>
                <div className="tm-blog-content">
                  <h6 className="tm-blog-title">
                    <Link to="/blogdetails" onClick={handleLinkClick}>
                     {t("blogdescription")}
                    </Link>
                  </h6>
                  {/* <ul class="tm-blog-meta">
									<li><a href="blog.html"><i class="ion-android-person"></i> Anderson</a></li>
									<li><a href="blog-details.html"><i class="ion-chatbubbles"></i> 3 Comments</a>
									</li>
								</ul> */}
                  <p>
                  {t("blogdescontent")}
                  </p>
                  {/* <Link
                    to="/blogdetails"
                    onClick={handleLinkClick}
                    className="tm-readmore"
                  >
                   {t("Readmore")}
                  </Link> */}
                </div>
              </div>
              <div className="tm-blog tm-scrollanim blog-leftBox">
                <div className="tm-blog-topside">
                  <div className="tm-blog-thumb">
                    <img
                      src="assets/images/blog/blog-image-4.jpg"
                      alt="blog image"
                    />
                  </div>
                  <span className="tm-blog-metahighlight">April 30, 2024</span>
                </div>
                <div className="tm-blog-content">
                  <h6 className="tm-blog-title">
                    <Link to="/blogdetails" onClick={handleLinkClick}>
                     {t("blogdescription")}
                    </Link>
                  </h6>
                  {/* <ul class="tm-blog-meta">
									<li><a href="blog.html"><i class="ion-android-person"></i> Anderson</a></li>
									<li><a href="blog-details.html"><i class="ion-chatbubbles"></i> 3 Comments</a>
									</li>
								</ul> */}
                  <p>
                    {t("blogdescontent")}
                  </p>
                  {/* <Link
                    to="/blogdetails"
                    onClick={handleLinkClick}
                    className="tm-readmore"
                  >
                 {t("Readmore")}
                  </Link> */}
                </div>
              </div>
              <div className="tm-blog tm-scrollanim blog-leftBox">
                <div className="tm-blog-topside">
                  <div className="tm-blog-thumb">
                    <img
                      src="assets/images/blog/blog-image-5.jpg"
                      alt="blog image"
                    />
                  </div>
                  <span className="tm-blog-metahighlight">April 30, 2024</span>
                </div>
                <div className="tm-blog-content">
                  <h6 className="tm-blog-title">
                    <Link to="/blogdetails" onClick={handleLinkClick}>
                     {t("blogdescription")}
                    </Link>
                  </h6>
                  {/* <ul class="tm-blog-meta">
									<li><a href="blog.html"><i class="ion-android-person"></i> Anderson</a></li>
									<li><a href="blog-details.html"><i class="ion-chatbubbles"></i> 3 Comments</a>
									</li>
								</ul> */}
                  <p>
                    {t("blogdescontent")}
                  </p>
                  {/* <Link
                    to="/blogdetails"
                    onClick={handleLinkClick}
                    className="tm-readmore"
                  >
                 {t("Readmore")}
                  </Link> */}
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </main>
    </div>
  );
};
export default Home;
